module.exports = __webpack_public_path__ + "img/course-4.37eeb324.jpeg";